<template>
  <div class="contactUs maxBox">
    <div class="banner contact_banner"></div>
    <!--  -->
    <div class="introduce">
      <div class="introduceTl">
        <div>公司简介</div>
        <p>我们专注做好每一件事</p>
      </div>
      <div class="introduceCon">
        <div>
          <p>
            慧飞河南新科技市场分校是大疆创新科技有限公司行业无人机河南省代理商，大疆创新科技有限公司授权维修服务商。慧飞无人机应用技术培训中心授权成立的河南新科技市场分校。
          </p>
          <p>
            慧飞河南新科技市场分校致力于打造国内一流的无人机智慧教育和地理信息行业培训，可以自行研发、组装、维修多旋翼、固定翼、复合翼无人机，与高等院校在无人机专业规划、课程设计、师资培养、实训实习、实验室建设等方面建立了良好的校企合作关系。
          </p>
          <p>
            学校具有一支专业性高、实战性强的教育培训队伍，能够在无人机及测绘行业应用方面全方位进行培训。公司采取是的前校后企的培训模式，让学员走入社会即可投入工作。慧飞河南新科技市场分校拥有一支技术过硬、经验丰富的航测、航拍的大队，能够多场景下实现无人机的飞行任务，在全国各地飞行了几百个项目。为无人机测绘技术培训提供了坚强的实训、实习支持。
          </p>
        </div>
        <div>
          <img src="../image/xinke1.jpg" alt="" />
        </div>
      </div>
    </div>
    <div class="contact_container">
      <div class="elective">
        <div>资质荣誉</div>
        <div>不断追求卓越,不断创新,不断提升自身实力</div>
      </div>
      <div class="group honor_four">
        <img src="../image/zizhi3.jpg" alt="" />
        <img src="../image/zizhi4.jpg" alt="" />
        <img src="../image/zizhi7.jpg" alt="" srcset="" />
        <img src="../image/zizhi8.jpg" alt="" />
        <img src="../image/zizhi9.jpg" alt="" />
        <img src="../image/zizhi10.jpg" alt="" />
        <img src="../image/zizhi11.jpg" alt="" srcset="" />
        <img src="../image/zizhi12.jpg" alt="" />
      </div>
      <div class="group honor_three">
        <img src="../image/zizhi2.jpg" alt="" srcset="" />
        <img src="../image/zizhi20.jpg" alt="" />
        <img src="../image/zizhi1.jpg" alt="" srcset="" />
        <img src="../image/zizhi17.jpg" alt="" />
        <img src="../image/zizhi16.jpg" alt="" srcset="" />
        <img src="../image/zizhi15.jpg" alt="" />
      </div>
    </div>

    <div class="contact_container">
      <div class="elective">
        <div>联系我们</div>
        <div>有任何问题，欢迎随时联系</div>
      </div>
      <ul class="three_phone">
        <li>
          <img src="../image/locaL.jpg" alt="" class="ctu" />
          <dd class="lxneir">
            <div>公司地址</div>
            <p>河南省 · 郑州市</p>
            <p>金水区杨金路199号新科技市场9号楼4层</p>
          </dd>
        </li>
        <li>
          <img src="../image/ope.jpg" alt="" class="ctu" />
          <dd class="lxneir2">
            <div>商务合作</div>
            <p>联系电话：15036062166</p>
          </dd>
        </li>
        <li>
          <img src="../image/zx.jpg" alt="" class="ctu" />
          <dd class="lxneir3">
            <div>咨询报名</div>
            <p>联系电话：15038061552</p>
            <p style="margin-left: 82px">15803862868</p>
          </dd>
        </li>
      </ul>
    </div>
    <div class="jiamap">
      <div class="pop">
        <div class="webname">优体希教育</div>
        <div>郑州市金水区杨金路199号新科技市场9号楼4层</div>
        <div class="maplocal" @click="trueMap">
          <img src="../image/zhidingweizhi.png" />
          定位到百度地图
        </div>
      </div>
      <div class="jianjiao"></div>
    </div>
  </div>
</template>

<script>
import "../css/index.css";
export default {
  data() {
    return {};
  },
  methods: {
    trueMap() {
      window.open(
        "https://map.baidu.com/search/%E6%96%B0%E7%A7%91%E6%8A%80%E5%B8%82%E5%9C%BA/@12660798.807771804,4118966.104999999,19z?querytype=s&da_src=shareurl&wd=%E6%96%B0%E7%A7%91%E6%8A%80%E5%B8%82%E5%9C%BA&c=1&src=0&pn=0&sug=0&l=5&b=(5094899.600002224,987382.6300052954;20823539.60000222,8663286.630005296)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&device_ratio=1"
      );
    },
  },
  created() {
    // router===VueRouter 是路由对象
    // console.log(this.$router);
    // 路由的基本参数信息
    // console.log(this.$route);
  },
};
</script>
<style scoped>
.prism-big-play-btn {
  transform: translate(-50%, -50%);
}
.player-wrapper {
  position: relative;
  z-index: 11111;
}
.honor_four img {
  display: block;
  width: 292px;
  height: 200px;
  margin: 5px 0px;
  margin-left: 10px;
}
.honor_four > img:nth-child(1),
.honor_three > img:nth-child(1),
.honor_four > img:nth-child(5),
.honor_three > img:nth-child(4) {
  margin-left: 0px;
}

.honor_three,
.honor_four {
  flex-wrap: wrap;
}
.honor_three img {
  width: 390px;
  height: 274px;
  margin: 10px 0px;
  margin-left: 15px;
}
.introduce {
  width: 1200px;
  margin: 0 auto;
  height: 522px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  margin-top: -100px;
  box-sizing: border-box;
}
.introduceTl {
  box-sizing: border-box;
  padding-top: 46px;
  margin-bottom: 23px;
  text-align: center;
}
.introduceTl div {
  font-size: 30px;
  margin-bottom: 5px;
}
.introduceTl p {
  font-size: 14px;
}
.introduceCon {
  width: 1120px;
  margin: 0 auto;
  text-align: left;
  display: flex;
  align-items: center;
}
.introduceCon img {
  display: inline-block;
  width: 459px;
  height: 342px;
  margin-left: 30px;
}
.introduceCon div {
  width: 615px;
  height: 325px;
  font-size: 16px;
}
.introduceCon p {
  text-indent: 2em;

  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
}
.contact_banner {
  background: url("../image/banner_about.jpg") no-repeat center center;
}

.ctu {
  width: 386px;
  height: 130px;
  border-radius: 8px;
}
.three_phone {
  display: flex;
  justify-content: center;
  margin-top: 45px;
  margin-bottom: 48px;
}
.three_phone li {
  margin-right: 20px;
}
.lxneir {
  margin-left: 22px;
}
.lxneir2,
.lxneir3 {
  margin-left: 80px;
}
.three_phone div {
  font-size: 22px;
  margin: 10px 0px;
}
.three_phone p {
  margin: 5px 0px;
}
.three_phone div,
.three_phone p {
  text-align: left;
}
/* .container {
  height: 500px;
} */
.webname {
  /* width: 67px; */
  height: 16px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 19px;
  margin: 10px 0px;
  text-align: center;
}
.jiamap {
  min-width: 1200px;
  height: 500px;
  background: url("../image/map.jpg");
}
.maplocal {
  /* width: 118px; */
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #048ae0;
  line-height: 19px;
  margin: 5px 0px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.maplocal a {
  text-decoration: none;
  color: #048ae0 !important;
}
.maplocal img {
  padding-top: 4px;
  display: inline-block;
  /* padding: 5px; */
}
.jianjiao {
  height: 20px;
  width: 20px;
  background: #fff;

  /* 旋转小方块并调整位置形成尖角 */
  position: relative;
  left: 950px;
  top: 160px;
  transform: rotate(45deg);
  border-right: 0px;
  border-bottom: 0px;
  filter: drop-shadow(1px 1px 1px #a5a5a5);
}

.pop {
  width: 396px;
  height: 100px;
  background: #ffffff;
  box-shadow: 2px 3px 18px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  filter: drop-shadow(0px 0px 1px #a9a9a9);
  position: absolute;
  margin: 70px 60px 60px 750px;
  text-align: center;
}
/* .BMap_Marker{
background: blue !important;
border-radius: 50%;
} */
</style>